import React from "react";
import { Container } from "react-bootstrap";
import "./QuoteSection.css"; // We'll create this CSS file

const QuoteSection = () => {
  const clients = [
    { src: "/logo/l&t.jpg", alt: "Larsen & Toubro" },
    { src: "/logo/kec.jpg", alt: "KEC" },
    { src: "/logo/Picture5.png", alt: "Thyssenkrupp" },
    { src: "/logo/Picture6.png", alt: "Kalpataru" },
    { src: "/logo/Picture7.png", alt: "ion exchange" },
    { src: "/logo/ORNET.png", alt: "ORNET" },
    { src: "/logo/VEDANTA.png", alt: "VEDANTA" },
    { src: "/logo/WRENCH.png", alt: "WRENCH" },
    { src: "/logo/XCEL.png", alt: "XCEL" },
    
  ];

  return (
    <Container className="my-5 py-4">
      <h4 className="section-title text-center mb-5">OUR CLIENTS</h4>
      <div className="client-slider-wrapper">
        <div className="client-slider-track">
          {[...clients, ...clients].map((client, index) => (
            <div key={index} className="client-slide">
              <img
                src={client.src}
                alt={client.alt}
                className="client-logo"
                loading="lazy"
              />
            </div>
          ))}
        </div>
      </div>
    </Container>
  );
};

export default QuoteSection;